import React from 'react';
import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { ExtendedUser } from '../../../Types';
import UserBadge from '../../Dashboard/DashboardComponents/UserBadge';

interface SelectedAssociateBannerProps {
  selectedDirectReport: ExtendedUser;
}

const SelectedAssociateBanner: React.FC<SelectedAssociateBannerProps> = ({
  selectedDirectReport,
}) => {
  return (
    <Box spacingInset='400'>
      <Row
        alignmentVertical='center'
        alignmentHorizontal='justify'
        width='100%'
      >
        {/* User info section - left aligned */}
        <Box>
          <Row alignmentVertical='center' spacing='300'>
            <UserBadge
              username={selectedDirectReport.alias}
              thumbNail
              thumbnailSize='medium'
            />
            <Text type='b400'>
              {selectedDirectReport.displayName} ({selectedDirectReport.alias})
            </Text>
          </Row>
        </Box>
      </Row>
    </Box>
  );
};

export default SelectedAssociateBanner;
